var badgesService = function () {
  this.add = function (model) {
    if (window.localStorage.getItem("rdp-super-app-badges") === null) {
      var data = [];
      for (let i = 0; i < 8; i++) {
        data.push({
          "label": null,
          "exist": false
        })
      }
      window.localStorage.setItem("rdp-super-app-badges", JSON.stringify(data));
    }

    var badges = JSON.parse(window.localStorage.getItem("rdp-super-app-badges"));

    for (var i = 0; i < badges.length; i++) {
      if (badges[i].exist === false) {
        badges[i] = model;
        break;
      };
    };

    window.localStorage.setItem("rdp-super-app-badges", JSON.stringify(badges));

  }

  this.exist = function(id) {
    var data = JSON.parse(window.localStorage.getItem("rdp-super-app-badges"));

    return data.filter(item => item.id === id).length > 0;
  }

  return this;
}

var BadgesService = new badgesService();

export {
  BadgesService
};